<template>
    <div class="shadow-[0px_0px_15px_-2px_#ccc] rounded-[20px] p-[20px] bg-white">
        <div class="flex justify-start items-center gap-1 pb-[20px]">
            <div class="w-[8px] h-[8px] rounded-full bg-purple-100" />
            <div class="w-[35px] h-[8px] rounded-full bg-purple-100" />
            <p class="text-[20px] font-bold font-roboto pl-2 m-0 text-[#333]">
                Internal Notes
            </p>
        </div>
        <div class="rounded-[10px] border-1 border-[#CCCCCC]">
            <div
ref="notesContainer" class="flex flex-col gap-2 p-2 min-h-[260px] max-h-[260px] overflow-x-hidden overflow-y-auto"
>
                <div v-for="(item, index) in jobNotes" :key="index">
                    <div class="relative p-2.5 !pr-[30px] rounded-[10px] bg-opacity-50 bg-[#EFEFEF]">
                        <p class="m-0 text-[12px] laptop:text-[14px] text-[#333333] break-all whitespace-pre-line">
                            {{
                                item.notes }}
                        </p>
                        <div
v-if="item.is_deletable == 1"
                            class="cursor-pointer absolute -bottom-3 right-3 w-[30px] h-[30px] p-1.5 rounded-full border-1 border-[#EFEFEF] bg-[#fff]"
                            @click="deleteNoteBtn(item)"
>
                            <img src="../../../assets/images/delete-card-icon.png" class="w-full h-full">
                        </div>
                    </div>
                    <div class="text-[11px] laptop:text-[13px] text-[#999999]">
                        {{ convertNotesTimsStampToDate(item.created_at) }}
                    </div>
                </div>

                <div v-if="jobNotes?.length < 1" class="text-center mt-3 text-[#999999]">
                    No notes available
                </div>
            </div>
            <div
                class="relative m-[5px] rounded-[10px] overflow-hidden shadow-[0px_0px_20px_0px_#00000026] flex items-end pr-[50px]"
>
                <!-- Textarea -->
                <textarea
ref="notesArea" v-model="notes" rows="1" class="w-full resize-none outline-none overflow-y-auto !p-[10px]
           min-h-[40px] max-h-[72px] hide-scrollbar leading-[20px] text-[#666666] text-[14px]"
                    placeholder="Write your Notes..." @input="autoResize"
/>

                <!-- Update Button -->
                <button
v-if="selectedNotes != null" :disabled="txtDisable" class="absolute right-0 bottom-0 h-[48px] px-3 rounded-[10px]
           bg-[#092E87] text-white disabled:bg-[#EFEFEF] disabled:text-[#999999]" @click="updateNotesBtn"
>
                    Update Note
                </button>

                <!-- Send Button -->
                <button v-else :disabled="txtDisable" class="group absolute right-[1px] bottom-[1px] h-[38px] w-[48px] flex items-center justify-center rounded-[10px]
           bg-[#7695FF] text-white disabled:bg-[#EFEFEF] disabled:text-[#999999]" @click="addNotesBtn">
                    <img src="../../../assets/images/sendIcon.png"
                        class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] group-disabled:filter group-disabled:brightness-[0.7]">
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    components: {},

    data() {
        return {
            modal: null,
            selectedNotes: null,
            notes: "",
            jobNotes: [],
            txtDisable: true,
        };
    },
    computed: {
        ...mapGetters(["quoteDetail", "notesData", "notesDataResponse"]),
    },

    watch: {
        notesData: function () {
            this.selectedNotes = null;
            this.notes = "";
            this.getNotesData()
        },

        notesDataResponse: function () {
            this.selectedNotes = null;
            this.notes = "";
            this.jobNotes = this.notesDataResponse ?? [];
            this.scrollToBottom()
        },

        notes: function () {
            if (!this.isEmpty(this.notes)) {
                this.txtDisable = false;
            } else {
                this.txtDisable = true;
            }
        },
    },

    mounted() {
        this.getNotesData()
    },

    methods: {
        ...mapActions(["updateNote", "addNote", "deleteNote", "getNotes"]),
        autoResize() {
            const textarea = this.$refs.notesArea;
            textarea.style.height = "auto";
            textarea.style.height = Math.min(textarea.scrollHeight, 72) + "px";
            // 72px = approx 3 lines
        },
        resetTextareaHeight() {
            this.$nextTick(() => {
                const textarea = this.$refs.notesArea;
                if (textarea) {
                    textarea.style.height = "40px"; // 1 line height reset
                }
            });
        },
        getNotesData() {
            this.getNotes({
                quote_id: this.quoteDetail.id,
            });
        },

        convertNotesTimsStampToDate(val) {
            return moment.unix(val).format("hh:mm A - MM/DD/YYYY");
        },
        editNoteBtn(data) {
            this.selectedNotes = data;
            this.notes = this.selectedNotes.notes;
        },
        deleteNoteBtn(data) {
            this.$dialog.show({
                title: "Delete Note",
                text: "Are you sure you want to delete this note?",
                // image: "pop-req-img.png",
                // we are passing callback method for our confirm button
                onConfirm: () => {
                    this.deleteNote({
                        id: data.id,
                    });
                },
            });
        },
        addNotesBtn() {
            if (this.isValid()) {
                this.addNote({
                    quote_id: this.quoteDetail.id,
                    notes: this.notes,
                });
            }
            this.notes = "";
            this.resetTextareaHeight();
        },
        updateNotesBtn() {
            if (this.isValid()) {
                this.updateNote({
                    id: this.selectedNotes.id,
                    notes: this.notes,
                });
            }
            this.notes = "";
            this.resetTextareaHeight();
        },
        isValid() {
            let res = true;
            if (this.isEmpty(this.notes)) {
                toast.error("Please enter note");
                res = false;
            }
            return res;
        },
        isEmpty(value) {
            return (
                value == null ||
                value.trim().length === 0 ||
                (value.constructor === Object && Object.keys(value).length === 0)
            );
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const el = this.$refs.notesContainer;
                if (el) {
                    el.scrollTop = el.scrollHeight;
                }
            });
        }
    },
};
</script>
<style>
/* Scrollbar hide for Chrome, Safari */
.hide-scrollbar::-webkit-scrollbar {
    display: none;
}

/* Scrollbar hide for Firefox */
.hide-scrollbar {
    scrollbar-width: none;
}

/* Scrollbar hide for IE/Edge */
.hide-scrollbar {
    -ms-overflow-style: none;
}
</style>